import React from 'react';

import { SettingsContent } from '../components/Settings/SettingsContent.component';

export const SettingsPage: React.FC = () => {
  return <SettingsContent />;
};
